export type TBetslipGlobalStateContext = {
  totalOdds: number;
};

export enum EBetslipGlobalStateActions {
  SET_TOTAL_ODDS = 'SET_TOTAL_ODDS'
}
